{
  "w": 16,
  "h": 24,
  "rows": [
    ".....GGG........",
    "...GGGWWW.G.....",
    "..GGWWWWGGGGW...",
    "..WWWWGGGGWWWW..",
    ".WWWGGGGWWWWG.G.",
    "WWGGGGWWWWGgGGW.",
    ".GGGWWWWGGGgWWW.",
    "GGWggggGGGgggWG.",
    "WWggggggWgggggG.",
    "GGgggggggggggg.G",
    ".G.gggggggggggg.",
    ".GGGggggggggggG.",
    "..GGGGgggggGGGG.",
    "....GGGGggG.G...",
    "......RRRg......",
    "......RRgR......",
    "......RRRR......",
    "......RRRR......",
    "......RRRR......",
    "......RRRR......",
    "......RRRR......",
    "......RRRR......",
    "......RRRR......",
    ".....WWWWWWW...."
  ],
  "legend": {
    "G": "C.B_GREEN",
    "g": "C.GREEN",
    "R": "C.RED",
    "W": "C.B_WHITE"
  }
}
